import * as React from "react";
import ReactDOM from "react-dom";
import { inject, observer } from "mobx-react";
import { Router as Router } from "react-router-dom";
import Master from "@templates/master";
import { observable } from "mobx";
import Grid from "@components/Grid/Grid";


class ConfirmationInfo extends React.Component {
    constructor(props) {
        super(props);
        this.infoDiv = React.createRef();
        this.renderSnippet = this.renderSnippet.bind(this);
    }


    renderSnippet(htmlSnippet) {

        if (this.infoDiv && this.infoDiv.current) {
            var infoContainer = this.infoDiv.current;
             
            infoContainer.innerHTML = htmlSnippet;
            var scriptsTags = infoContainer.getElementsByTagName('script');
            // This is necessary otherwise the scripts tags are not going to be evaluated
            for (var i = 0; i < scriptsTags.length; i++) {
                var parentNode = scriptsTags[i].parentNode;
                var newScriptTag = document.createElement('script');
                newScriptTag.type = 'text/javascript';
                newScriptTag.text = scriptsTags[i].text;
                parentNode.removeChild(scriptsTags[i]);
                parentNode.appendChild(newScriptTag);
            }
        }
    }

    componentDidMount() {
        const order = this.props.order;

        if (order.AdditionalData && order.AdditionalData.klarna_checkoutsnippet) {
            this.renderSnippet(order.AdditionalData.klarna_checkoutsnippet);
        }
    }

    render() {
        const order = this.props.order;
        const dictionary = this.props.dictionary;
        //const shippingMethod = order.ShippingMethods.find(x => x.ShippingMethodId === order.ShippingMethodId);

        let sortedLines = [];

        if (order && order.ProductList && order.ProductList.length > 0) {
            let visualOrderLines = [];
            order.ProductList.map(product => {
                product.OrderLines.map(orderLine => {
                    visualOrderLines.push(orderLine);
                });
            });

            sortedLines = visualOrderLines.slice().sort(function (a, b) {
                const sortValueA = a.IsGenerated ? 1 : 0;
                const sortValueB = b.IsGenerated ? 1 : 0;

                if (sortValueA < sortValueB) return -1;
                if (sortValueA > sortValueB) return 1;
                return 0;
            });
        }

        return (
            <div className="confirmation" ref={this.infoDiv}>
                <p className="email-info">
                    {dictionary.ConfirmationWillBeSentTo} {order.BillingAddress.EmailAddress}

                </p>
                <dl className="cart-order-totals">
                    <dt>{dictionary.ConfirmationYourOrderNumber}
                    </dt>
                    <dd>
                        {order.OrderNumber}
                    </dd>


                    <dt className="cart-title-total">{dictionary.TotalInclTax}</dt>
                    <dd className="cart-sum-total">{order.OrderTotalFormatted === "0.00" || order.OrderTotalFormatted === "0,00" ? 0 : order.OrderTotalFormatted} {order.Currency} <br /><span className="vat-info">{dictionary.VatTotal} {order.VATFormatted === "0.00" || order.VATFormatted === "0,00" ? 0 : order.VATFormatted} {order.Currency}</span></dd>

                </dl>
            </div>);
    }

}

@inject("store")
@observer
export default class ConfirmationTemplate extends React.Component {
    @observable confirmBasket = null;
    constructor(props) {
        super(props);
        this.state = { res: null, update: 0 };
    }


    componentDidMount() {
        // is this a checkout?, or confirmation?
        var parsedQuery = this.props.store.navigation.getParsedQueryString();
        const confirmationDiv = document.querySelector('#Confirmation');

        if (confirmationDiv) {
            confirmationDiv.innerHTML = "Loading...";
            this.props.store.order.getConfirmation(parsedQuery.orderGuid).then(res => {

                //this.renderSnippet(res.AdditionalData.klarna_checkoutsnippet);
                if (confirmationDiv) {
                    ReactDOM.render(
                        <ConfirmationInfo order={res} dictionary={this.props.store.navigation.dictionary} />,
                        confirmationDiv);
                }
                this.props.store.analytics.purchase(res);

                this.setState({ res: res });
            });
        } else {
            const that = this;
            setTimeout(function () { that.setState({ update: 1 }); }, 1000);
        }
    }


    componentDidUpdate() {

       if (!this.state.res) {
           var parsedQuery = this.props.store.navigation.getParsedQueryString();
           const confirmationDiv = document.querySelector('#Confirmation');

           if (confirmationDiv) {
               confirmationDiv.innerHTML = "Loading...";
               this.props.store.order.getConfirmation(parsedQuery.orderGuid).then(res => {

                   //this.renderSnippet(res.AdditionalData.klarna_checkoutsnippet);
                   if (confirmationDiv) {
                       ReactDOM.render(<ConfirmationInfo order={res} dictionary={this.props.store.navigation.dictionary} />, confirmationDiv);
                   }
                   this.props.store.analytics.purchase(res);

                   this.setState({ res: res });
               });
           }
       }
    }

    render() {
        // query: Confirm="basketid"
        const res = this.state.res;
        return (
            <Master {...this.props}>
                <div className="container-fluid">
                    <Grid {...this.props} model={this.props.navigation.pageContent.Properties.grid} />
                </div>

                {res && <div className="order-confirmation-summary" style={{ "display": "none" }}>
                    <div className="order-total-inc-vat">{res.OrderTotalFormatted}</div>
                    <div className="order-subtotal">{res.SubTotalWithVATFormatted}</div>
                    <div className="order-vat">{res.VATFormatted}</div>
                    <div className="order-currency">{res.CurrencyCode}</div>

                </div>}
            </Master>
        );
    }
}

